var _rect, _text, _rect2, _circle, _line, _line2, _text2, _rect3, _circle2, _line3, _text3, _rect4, _rect5, _line4, _text4, _path, _rect6, _path2, _path3, _text5, _path4, _rect7, _rect8, _rect9, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _line5, _text13, _text14, _text15, _text16, _text17, _text18, _circle3, _circle4, _text19, _text20, _rect0, _rect1, _text21, _rect10, _rect11, _text22, _rect12, _rect13, _text23, _rect14, _rect15, _rect16, _circle5, _text24, _circle6, _circle7, _circle8, _line6, _text25, _text26, _text27, _text28, _text29, _text30, _circle9, _circle0, _text31, _text32, _rect17, _rect18, _text33, _rect19, _rect20, _text34, _rect21, _rect22, _text35, _rect23, _rect24, _rect25, _circle1, _text36, _circle10, _circle11, _circle12, _line7, _text37, _text38, _text39, _text40, _text41, _text42, _circle13, _circle14, _text43, _text44, _rect26, _rect27, _text45, _rect28, _rect29, _text46, _rect30, _rect31, _text47, _rect32, _rect33, _rect34, _circle15, _text48, _circle16, _circle17, _circle18, _line8, _text49, _text50, _text51, _text52, _text53, _text54, _circle19, _circle20, _text55, _text56, _rect35, _rect36, _text57, _rect37, _rect38, _text58, _rect39, _rect40, _text59, _rect41, _rect42, _rect43, _circle21, _text60, _circle22, _circle23, _circle24, _line9, _text61, _text62, _text63, _text64, _text65, _text66, _circle25, _circle26, _text67, _text68, _rect44, _rect45, _text69, _rect46, _rect47, _text70, _rect48, _rect49, _text71, _rect50, _rect51, _rect52, _circle27, _text72, _circle28, _circle29, _circle30, _line0, _text73, _text74, _rect53, _text75, _path5, _rect54, _path6, _rect55, _text76, _rect56, _text77, _rect57, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCandidatesList = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1920 1260",
  width: 1920,
  height: 1260,
  xmlns: "http://www.w3.org/2000/svg",
  fontFamily: "Arial, Helvetica, sans-serif",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 1920,
  height: 1260,
  fill: "#f1f5f9"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 56,
  y: 92,
  fontSize: 52,
  fontWeight: 900,
  fill: "#0b0f19"
}, "Candidates")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 46,
  width: 262,
  height: 62,
  rx: 14,
  fill: "#2f5bff"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1636,
  cy: 77,
  r: 11,
  fill: "none",
  stroke: "white",
  strokeWidth: 2
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1636,
  y1: 72,
  x2: 1636,
  y2: 82,
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 1631,
  y1: 77,
  x2: 1641,
  y2: 77,
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 1658,
  y: 85,
  fill: "white",
  fontSize: 20,
  fontWeight: 700
}, "Upload Transcript")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 146,
  width: 1274,
  height: 62,
  rx: 12,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 177,
  r: 9,
  fill: "none",
  stroke: "#94a3b8",
  strokeWidth: 2
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 101,
  y1: 184,
  x2: 109,
  y2: 192,
  stroke: "#94a3b8",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 122,
  y: 184,
  fontSize: 20,
  fill: "#94a3b8"
}, "Search candidates...")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 1352,
  y: 146,
  width: 194,
  height: 62,
  rx: 12,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 1376,
  y: 164,
  width: 20,
  height: 18,
  rx: 3,
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 2
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 1376,
  y1: 170,
  x2: 1396,
  y2: 170,
  stroke: "#2563eb",
  strokeWidth: 2
})), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
  x: 1406,
  y: 184,
  fontSize: 20,
  fontWeight: 700,
  fill: "#0f172a"
}, "All time")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M 1522 176 L 1530 184 L 1538 176",
  fill: "none",
  stroke: "#334155",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 1568,
  y: 146,
  width: 300,
  height: 62,
  rx: 12,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M 1592 168 L 1592 186 M 1588 182 L 1592 186 L 1596 182",
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M 1602 186 L 1602 168 M 1598 172 L 1602 168 L 1606 172",
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
  x: 1618,
  y: 184,
  fontSize: 20,
  fill: "#334155"
}, "Sort: ", /*#__PURE__*/React.createElement("tspan", {
  fontWeight: 800,
  fill: "#0f172a"
}, "Overall score"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M 1836 174 L 1844 184 L 1852 174",
  fill: "none",
  stroke: "#334155",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 228,
  width: 1808,
  height: 964,
  rx: 16,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 228,
  width: 1808,
  height: 56,
  rx: 16,
  fill: "#f8fafc"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 256,
  width: 1808,
  height: 28,
  fill: "#f8fafc"
})), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "#")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "CANDIDATE")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "EMAIL")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
  x: 746,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "OVERALL")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "COMM.")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "WORK LEVEL")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "EXECUTION")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "CRIT. THINK.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
  x: 1602,
  y: 264,
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: 0.5,
  fill: "#64748b"
}, "STATUS")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 284,
  x2: 1864,
  y2: 284,
  stroke: "#e2e8f0"
})), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 366,
  fontSize: 28,
  fill: "#94a3b8"
}, "1")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 326,
  fontSize: 24,
  fontWeight: 800,
  fill: "#0f172a"
}, "Maya Chen")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 356,
  fontSize: 20,
  fontWeight: 700,
  fill: "#334155"
}, "Strategic Technical Leader")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 386,
  fontSize: 16,
  fill: "#94a3b8"
}, "Staff Backend Engineer \u2022 System \u2022")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 412,
  fontSize: 16,
  fill: "#94a3b8"
}, "Jun 9, 2026")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 374,
  fontSize: 20,
  fill: "#334155"
}, "maya.chen@qatest...")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 365,
  r: 34,
  fill: "none",
  stroke: "#e5e9f0",
  strokeWidth: 9
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 365,
  r: 34,
  fill: "none",
  stroke: "#16a34a",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeDasharray: "194.40 213.63",
  transform: "rotate(-90 791 365)"
})), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 375,
  textAnchor: "middle",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 28,
  fontWeight: 800,
  fill: "#16a34a"
}, "91")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 360,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "88")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 374,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 374,
  width: 123.2,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 360,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "94")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 374,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 374,
  width: 131.6,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 360,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "90")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 374,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 374,
  width: 126,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 360,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "92")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 374,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 374,
  width: 128.8,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 346,
  width: 112,
  height: 38,
  rx: 19,
  fill: "#dcfce7"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 1620,
  cy: 365,
  r: 4,
  fill: "#16a34a"
})), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
  x: 1632,
  y: 371,
  fontSize: 18,
  fontWeight: 700,
  fill: "#16a34a"
}, "Scored")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 356,
  r: 3,
  fill: "#94a3b8"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 365,
  r: 3,
  fill: "#94a3b8"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 374,
  r: 3,
  fill: "#94a3b8"
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 447,
  x2: 1864,
  y2: 447,
  stroke: "#e2e8f0"
})), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 529,
  fontSize: 28,
  fill: "#94a3b8"
}, "2")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 489,
  fontSize: 24,
  fontWeight: 800,
  fill: "#0f172a"
}, "Devon Reyes")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 519,
  fontSize: 20,
  fontWeight: 700,
  fill: "#334155"
}, "Product-Minded Engineer")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 549,
  fontSize: 16,
  fill: "#94a3b8"
}, "Senior Full-Stack Engineer \u2022")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 575,
  fontSize: 16,
  fill: "#94a3b8"
}, "A. Okafor \u2022 Jun 8, 2026")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 537,
  fontSize: 20,
  fill: "#334155"
}, "devon.reyes@qate...")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 528,
  r: 34,
  fill: "none",
  stroke: "#e5e9f0",
  strokeWidth: 9
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 528,
  r: 34,
  fill: "none",
  stroke: "#16a34a",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeDasharray: "179.45 213.63",
  transform: "rotate(-90 791 528)"
})), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 538,
  textAnchor: "middle",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 28,
  fontWeight: 800,
  fill: "#16a34a"
}, "84")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 523,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "90")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 537,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 537,
  width: 126,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 523,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "82")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 537,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 537,
  width: 114.8,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 523,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "85")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 537,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 537,
  width: 119,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 523,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "80")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 537,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 537,
  width: 112,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 509,
  width: 112,
  height: 38,
  rx: 19,
  fill: "#dcfce7"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 1620,
  cy: 528,
  r: 4,
  fill: "#16a34a"
})), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
  x: 1632,
  y: 534,
  fontSize: 18,
  fontWeight: 700,
  fill: "#16a34a"
}, "Scored")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 519,
  r: 3,
  fill: "#94a3b8"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 528,
  r: 3,
  fill: "#94a3b8"
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 537,
  r: 3,
  fill: "#94a3b8"
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 610,
  x2: 1864,
  y2: 610,
  stroke: "#e2e8f0"
})), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 692,
  fontSize: 28,
  fill: "#94a3b8"
}, "3")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 652,
  fontSize: 24,
  fontWeight: 800,
  fill: "#0f172a"
}, "Priya Nair")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 682,
  fontSize: 20,
  fontWeight: 700,
  fill: "#334155"
}, "Collaborative Builder")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 712,
  fontSize: 16,
  fill: "#94a3b8"
}, "Senior Backend Engineer \u2022 System")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 738,
  fontSize: 16,
  fill: "#94a3b8"
}, "\u2022 Jun 6, 2026")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 700,
  fontSize: 20,
  fill: "#334155"
}, "priya.nair@qatest.co")), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 691,
  r: 34,
  fill: "none",
  stroke: "#e5e9f0",
  strokeWidth: 9
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 691,
  r: 34,
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeDasharray: "166.63 213.63",
  transform: "rotate(-90 791 691)"
})), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 701,
  textAnchor: "middle",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 28,
  fontWeight: 800,
  fill: "#2563eb"
}, "78")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 686,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#16a34a"
}, "82")), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 700,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 700,
  width: 114.8,
  height: 8,
  rx: 4,
  fill: "#22c55e"
})), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 686,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "74")), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 700,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 700,
  width: 103.6,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 686,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "79")), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 700,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 700,
  width: 110.6,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 686,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "76")), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 700,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 700,
  width: 106.4,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 672,
  width: 112,
  height: 38,
  rx: 19,
  fill: "#dcfce7"
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 1620,
  cy: 691,
  r: 4,
  fill: "#16a34a"
})), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
  x: 1632,
  y: 697,
  fontSize: 18,
  fontWeight: 700,
  fill: "#16a34a"
}, "Scored")), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 682,
  r: 3,
  fill: "#94a3b8"
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 691,
  r: 3,
  fill: "#94a3b8"
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 700,
  r: 3,
  fill: "#94a3b8"
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 773,
  x2: 1864,
  y2: 773,
  stroke: "#e2e8f0"
})), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 855,
  fontSize: 28,
  fill: "#94a3b8"
}, "4")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 815,
  fontSize: 24,
  fontWeight: 800,
  fill: "#0f172a"
}, "Marcus Webb")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 845,
  fontSize: 20,
  fontWeight: 700,
  fill: "#334155"
}, "Pragmatic Operator")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 875,
  fontSize: 16,
  fill: "#94a3b8"
}, "Platform Engineer \u2022 A. Okafor \u2022")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 901,
  fontSize: 16,
  fill: "#94a3b8"
}, "Jun 2, 2026")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 863,
  fontSize: 20,
  fill: "#334155"
}, "marcus.webb@qat...")), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 854,
  r: 34,
  fill: "none",
  stroke: "#e5e9f0",
  strokeWidth: 9
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 854,
  r: 34,
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeDasharray: "151.68 213.63",
  transform: "rotate(-90 791 854)"
})), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 864,
  textAnchor: "middle",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 28,
  fontWeight: 800,
  fill: "#2563eb"
}, "71")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 849,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "70")), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 863,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 863,
  width: 98,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 849,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "75")), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 863,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 863,
  width: 105,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 849,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "74")), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 863,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 863,
  width: 103.6,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 849,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "68")), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 863,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 863,
  width: 95.2,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 835,
  width: 112,
  height: 38,
  rx: 19,
  fill: "#dcfce7"
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 1620,
  cy: 854,
  r: 4,
  fill: "#16a34a"
})), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
  x: 1632,
  y: 860,
  fontSize: 18,
  fontWeight: 700,
  fill: "#16a34a"
}, "Scored")), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 845,
  r: 3,
  fill: "#94a3b8"
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 854,
  r: 3,
  fill: "#94a3b8"
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 863,
  r: 3,
  fill: "#94a3b8"
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 936,
  x2: 1864,
  y2: 936,
  stroke: "#e2e8f0"
})), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 1018,
  fontSize: 28,
  fill: "#94a3b8"
}, "5")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 978,
  fontSize: 24,
  fontWeight: 800,
  fill: "#0f172a"
}, "Sofia Alvarez")), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 1008,
  fontSize: 20,
  fontWeight: 700,
  fill: "#334155"
}, "Emerging Contributor")), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 1038,
  fontSize: 16,
  fill: "#94a3b8"
}, "Backend Engineer II \u2022 System \u2022")), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
  x: 155,
  y: 1064,
  fontSize: 16,
  fill: "#94a3b8"
}, "May 28, 2026")), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
  x: 489,
  y: 1026,
  fontSize: 20,
  fill: "#334155"
}, "sofia.alvarez@qate...")), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 1017,
  r: 34,
  fill: "none",
  stroke: "#e5e9f0",
  strokeWidth: 9
})), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
  cx: 791,
  cy: 1017,
  r: 34,
  fill: "none",
  stroke: "#2563eb",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeDasharray: "136.72 213.63",
  transform: "rotate(-90 791 1017)"
})), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 1027,
  textAnchor: "middle",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 28,
  fontWeight: 800,
  fill: "#2563eb"
}, "64")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 1012,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "68")), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 1026,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  x: 900,
  y: 1026,
  width: 95.2,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
  x: 1070,
  y: 1012,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "62")), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 1026,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  x: 1070,
  y: 1026,
  width: 86.8,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
  x: 1252,
  y: 1012,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "66")), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 1026,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  x: 1252,
  y: 1026,
  width: 92.4,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
  x: 1428,
  y: 1012,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  fill: "#2563eb"
}, "63")), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 1026,
  width: 140,
  height: 8,
  rx: 4,
  fill: "#e5e9f0"
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  x: 1428,
  y: 1026,
  width: 88.2,
  height: 8,
  rx: 4,
  fill: "#3b82f6"
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  x: 1602,
  y: 998,
  width: 112,
  height: 38,
  rx: 19,
  fill: "#dcfce7"
})), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
  cx: 1620,
  cy: 1017,
  r: 4,
  fill: "#16a34a"
})), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
  x: 1632,
  y: 1023,
  fontSize: 18,
  fontWeight: 700,
  fill: "#16a34a"
}, "Scored")), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 1008,
  r: 3,
  fill: "#94a3b8"
})), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 1017,
  r: 3,
  fill: "#94a3b8"
})), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
  cx: 1810,
  cy: 1026,
  r: 3,
  fill: "#94a3b8"
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 1099,
  x2: 1864,
  y2: 1099,
  stroke: "#e2e8f0"
})), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
  x: 97,
  y: 1144,
  fontSize: 20,
  fill: "#334155"
}, "Showing ", /*#__PURE__*/React.createElement("tspan", {
  fontWeight: 800,
  fill: "#0f172a"
}, "1\u20135"), " of ", /*#__PURE__*/React.createElement("tspan", {
  fontWeight: 800,
  fill: "#0f172a"
}, "7"), " candidates")), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
  x: 1338,
  y: 1144,
  fontSize: 18,
  fill: "#475569"
}, "Rows per page")), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  x: 1500,
  y: 1121,
  width: 70,
  height: 44,
  rx: 10,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
  x: 1518,
  y: 1149,
  fontSize: 20,
  fontWeight: 700,
  fill: "#0f172a"
}, "5")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M 1548 1139 L 1554 1145 L 1560 1139",
  fill: "none",
  stroke: "#334155",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  x: 1608,
  y: 1121,
  width: 46,
  height: 46,
  rx: 10,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M 1634 1136 L 1624 1144 L 1634 1152",
  fill: "none",
  stroke: "#334155",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  x: 1666,
  y: 1121,
  width: 46,
  height: 46,
  rx: 10,
  fill: "#2f5bff"
})), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
  x: 1684,
  y: 1150,
  fontSize: 20,
  fontWeight: 700,
  fill: "white"
}, "1")), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  x: 1724,
  y: 1121,
  width: 46,
  height: 46,
  rx: 10,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
  x: 1742,
  y: 1150,
  fontSize: 20,
  fontWeight: 700,
  fill: "#0f172a"
}, "2")), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  x: 1782,
  y: 1121,
  width: 46,
  height: 46,
  rx: 10,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M 1798 1136 L 1808 1144 L 1798 1152",
  fill: "none",
  stroke: "#334155",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCandidatesList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/candidates-list.5f9638e36b9bef8f5aa496f8e1459470.svg";